// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    background-color: rgb(168, 214, 176); /* Set the background color of the body to black */
    margin: 0; /* Remove default margin */
    padding: 0; /* Remove default padding */
  }

.photo-container {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
  }

  .photo {
    position: relative;
    width: 240px; /* Adjust this value to change the size of the photo frame */
    height: 300px; /* Adjust this value to change the size of the photo frame */
    perspective: 1000px;
    margin: 20px
  }

  .table_foto {
    position: relative;
    max-width: 30%; /* Adjust this value to change the size of the photo frame */
    display: block;
    margin-left: auto;
    margin-right: auto;
  }

  /* Modal styles */
  .photo-modal2 {
    display: block;
    position: fixed;
    z-index: 1;
    left: 0;
    top: 0;
    width: 100%; /* Adjust this value to change the size of the photo frame */
    height: 100%; /* Adjust this value to change the size of the photo frame */
    perspective: 1000px;
    overflow: auto;
    display: flex;
    flex-wrap: wrap;
    margin: 0px;
    background-color: black!important;
    border-color: transparent!important;
    outline: transparent!important;
  }



  .photo-frame {
    width: 100%;
    height: 100%;
    background-color: white;
    border: 1px solid black; /* Frame border color */
    border-radius: 10px; /* Adjust this value to change the roundness of the corners */
    padding: 20px; /* Adjust this value to increase/decrease the size of the canvas */
    transform-style: preserve-3d;
    transition: transform 0.3s;
    display: flex;
    flex-direction: column;
    box-shadow: 0 4px 8px black; /* Add shadow effect */
  }

  .photo.active .photo-frame {
    transform: rotateX(5deg);
  }

  .photo img {
    width: 99%; /* Make sure the image fills the container */
    height: 85%; /* Make sure the image fills the container */
    object-fit: cover; /* Maintain aspect ratio and fill the container */
  }

  .controls {
    margin-top: 20px;
  }

  .photo-text {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    overflow: unset;
    display:unset;
    text-align: center; /* Center the text horizontally */
    margin-bottom: 10px; /* Adjust the distance from the bottom */
    color: black; /* Set the text color */
    font-size: 14px; /* Set the font size */
    font-family: "Protest Riot", sans-serif;
    font-weight: 400;
    font-style: normal;
  }

  .photo-modal-text {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    text-align: center; /* Center the text horizontally */
    margin-bottom: 10px; /* Adjust the distance from the bottom */
    color: black; /* Set the text color */
    font-size: 14px; /* Set the font size */
    font-family: "Protest Riot", sans-serif;
    font-weight: 400;
    font-style: normal;
  }

  .modal2 {
    display: block;
    position: fixed;
    z-index: 1;
    left: 0;
    top: 0;
    overflow: auto;
    background-color: rgba(0, 0, 0, 0.4);
  }


.photo-modal-content {
  background-color: transparent!important;
  border-color: transparent!important;
  outline: transparent!important;
  margin: 0% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 50%;
  color: white;
  position: relative;
}

.close {
  color: black;
}

.funktionsknopf {
    margin: 10px;
}

.photo-modal {
  position: relative;
  z-index: 1;
  left: 0;
  top: 0;
  width: 480px; /* Adjust this value to change the size of the photo frame */
  height: 80%; /* Adjust this value to change the size of the photo frame */
  perspective: 1000px;
  margin: 10px;
  display: flex;
  flex-wrap: wrap;
  overflow: auto;
  background-color: transparent!important;
  border-color: transparent!important;
  outline: transparent!important;
}

.assignModal {
  position: absolute;
  z-index: 1;
  left: 0;
  top: 0;
  width: auto; /* Adjust this value to change the size of the photo frame */
  height: auto; /* Adjust this value to change the size of the photo frame */
  perspective: 1000px;
  display: flex;
  flex-wrap: wrap;
  overflow: auto;
  margin: 20px;
  background-color: transparent!important;
  border-color: transparent!important;
  outline: transparent!important;
}

.assignModalContent {
  background-color: black;
  z-index: 1;
  position: absolute;
  border-color: transparent!important;
  outline: transparent!important;
  perspective: 1000px;
  margin: auto;
  padding: 20px;
  border: 20px solid #888;
  width: 50%;
  color: white;
  position: relative;
  overflow: auto;
}

  /* Modal styles */
  .photo-modal2 {
    display: block;
    position: fixed;
    z-index: 1;
    left: 0;
    top: 0;
    width: 100%; /* Adjust this value to change the size of the photo frame */
    height: 100%; /* Adjust this value to change the size of the photo frame */
    perspective: 1000px;
    overflow: auto;
    display: flex;
    flex-wrap: wrap;
    margin: 0px;
    background-color: black!important;
    border-color: transparent!important;
    outline: transparent!important;
  }`, "",{"version":3,"sources":["webpack://./src/Components/Galerie.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC,EAAE,kDAAkD;IACxF,SAAS,EAAE,0BAA0B;IACrC,UAAU,EAAE,2BAA2B;EACzC;;AAEF;IACI,aAAa;IACb,eAAe;IACf,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,YAAY,EAAE,4DAA4D;IAC1E,aAAa,EAAE,4DAA4D;IAC3E,mBAAmB;IACnB;EACF;;EAEA;IACE,kBAAkB;IAClB,cAAc,EAAE,4DAA4D;IAC5E,cAAc;IACd,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA,iBAAiB;EACjB;IACE,cAAc;IACd,eAAe;IACf,UAAU;IACV,OAAO;IACP,MAAM;IACN,WAAW,EAAE,4DAA4D;IACzE,YAAY,EAAE,4DAA4D;IAC1E,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,eAAe;IACf,WAAW;IACX,iCAAiC;IACjC,mCAAmC;IACnC,8BAA8B;EAChC;;;;EAIA;IACE,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,uBAAuB,EAAE,uBAAuB;IAChD,mBAAmB,EAAE,6DAA6D;IAClF,aAAa,EAAE,kEAAkE;IACjF,4BAA4B;IAC5B,0BAA0B;IAC1B,aAAa;IACb,sBAAsB;IACtB,2BAA2B,EAAE,sBAAsB;EACrD;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,UAAU,EAAE,4CAA4C;IACxD,WAAW,EAAE,4CAA4C;IACzD,iBAAiB,EAAE,iDAAiD;EACtE;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,eAAe;IACf,aAAa;IACb,kBAAkB,EAAE,iCAAiC;IACrD,mBAAmB,EAAE,wCAAwC;IAC7D,YAAY,EAAE,uBAAuB;IACrC,eAAe,EAAE,sBAAsB;IACvC,uCAAuC;IACvC,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,kBAAkB,EAAE,iCAAiC;IACrD,mBAAmB,EAAE,wCAAwC;IAC7D,YAAY,EAAE,uBAAuB;IACrC,eAAe,EAAE,sBAAsB;IACvC,uCAAuC;IACvC,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,UAAU;IACV,OAAO;IACP,MAAM;IACN,cAAc;IACd,oCAAoC;EACtC;;;AAGF;EACE,uCAAuC;EACvC,mCAAmC;EACnC,8BAA8B;EAC9B,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,MAAM;EACN,YAAY,EAAE,4DAA4D;EAC1E,WAAW,EAAE,4DAA4D;EACzE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,cAAc;EACd,uCAAuC;EACvC,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,MAAM;EACN,WAAW,EAAE,4DAA4D;EACzE,YAAY,EAAE,4DAA4D;EAC1E,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,cAAc;EACd,YAAY;EACZ,uCAAuC;EACvC,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,UAAU;EACV,kBAAkB;EAClB,mCAAmC;EACnC,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;EAEE,iBAAiB;EACjB;IACE,cAAc;IACd,eAAe;IACf,UAAU;IACV,OAAO;IACP,MAAM;IACN,WAAW,EAAE,4DAA4D;IACzE,YAAY,EAAE,4DAA4D;IAC1E,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,eAAe;IACf,WAAW;IACX,iCAAiC;IACjC,mCAAmC;IACnC,8BAA8B;EAChC","sourcesContent":["body {\r\n    background-color: rgb(168, 214, 176); /* Set the background color of the body to black */\r\n    margin: 0; /* Remove default margin */\r\n    padding: 0; /* Remove default padding */\r\n  }\r\n\r\n.photo-container {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    gap: 20px;\r\n  }\r\n\r\n  .photo {\r\n    position: relative;\r\n    width: 240px; /* Adjust this value to change the size of the photo frame */\r\n    height: 300px; /* Adjust this value to change the size of the photo frame */\r\n    perspective: 1000px;\r\n    margin: 20px\r\n  }\r\n\r\n  .table_foto {\r\n    position: relative;\r\n    max-width: 30%; /* Adjust this value to change the size of the photo frame */\r\n    display: block;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n  }\r\n\r\n  /* Modal styles */\r\n  .photo-modal2 {\r\n    display: block;\r\n    position: fixed;\r\n    z-index: 1;\r\n    left: 0;\r\n    top: 0;\r\n    width: 100%; /* Adjust this value to change the size of the photo frame */\r\n    height: 100%; /* Adjust this value to change the size of the photo frame */\r\n    perspective: 1000px;\r\n    overflow: auto;\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    margin: 0px;\r\n    background-color: black!important;\r\n    border-color: transparent!important;\r\n    outline: transparent!important;\r\n  }\r\n\r\n\r\n\r\n  .photo-frame {\r\n    width: 100%;\r\n    height: 100%;\r\n    background-color: white;\r\n    border: 1px solid black; /* Frame border color */\r\n    border-radius: 10px; /* Adjust this value to change the roundness of the corners */\r\n    padding: 20px; /* Adjust this value to increase/decrease the size of the canvas */\r\n    transform-style: preserve-3d;\r\n    transition: transform 0.3s;\r\n    display: flex;\r\n    flex-direction: column;\r\n    box-shadow: 0 4px 8px black; /* Add shadow effect */\r\n  }\r\n\r\n  .photo.active .photo-frame {\r\n    transform: rotateX(5deg);\r\n  }\r\n\r\n  .photo img {\r\n    width: 99%; /* Make sure the image fills the container */\r\n    height: 85%; /* Make sure the image fills the container */\r\n    object-fit: cover; /* Maintain aspect ratio and fill the container */\r\n  }\r\n\r\n  .controls {\r\n    margin-top: 20px;\r\n  }\r\n\r\n  .photo-text {\r\n    position: absolute;\r\n    bottom: 0;\r\n    left: 0;\r\n    right: 0;\r\n    overflow: unset;\r\n    display:unset;\r\n    text-align: center; /* Center the text horizontally */\r\n    margin-bottom: 10px; /* Adjust the distance from the bottom */\r\n    color: black; /* Set the text color */\r\n    font-size: 14px; /* Set the font size */\r\n    font-family: \"Protest Riot\", sans-serif;\r\n    font-weight: 400;\r\n    font-style: normal;\r\n  }\r\n\r\n  .photo-modal-text {\r\n    position: absolute;\r\n    bottom: 0;\r\n    left: 0;\r\n    right: 0;\r\n    text-align: center; /* Center the text horizontally */\r\n    margin-bottom: 10px; /* Adjust the distance from the bottom */\r\n    color: black; /* Set the text color */\r\n    font-size: 14px; /* Set the font size */\r\n    font-family: \"Protest Riot\", sans-serif;\r\n    font-weight: 400;\r\n    font-style: normal;\r\n  }\r\n\r\n  .modal2 {\r\n    display: block;\r\n    position: fixed;\r\n    z-index: 1;\r\n    left: 0;\r\n    top: 0;\r\n    overflow: auto;\r\n    background-color: rgba(0, 0, 0, 0.4);\r\n  }\r\n\r\n\r\n.photo-modal-content {\r\n  background-color: transparent!important;\r\n  border-color: transparent!important;\r\n  outline: transparent!important;\r\n  margin: 0% auto;\r\n  padding: 20px;\r\n  border: 1px solid #888;\r\n  width: 50%;\r\n  color: white;\r\n  position: relative;\r\n}\r\n\r\n.close {\r\n  color: black;\r\n}\r\n\r\n.funktionsknopf {\r\n    margin: 10px;\r\n}\r\n\r\n.photo-modal {\r\n  position: relative;\r\n  z-index: 1;\r\n  left: 0;\r\n  top: 0;\r\n  width: 480px; /* Adjust this value to change the size of the photo frame */\r\n  height: 80%; /* Adjust this value to change the size of the photo frame */\r\n  perspective: 1000px;\r\n  margin: 10px;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  overflow: auto;\r\n  background-color: transparent!important;\r\n  border-color: transparent!important;\r\n  outline: transparent!important;\r\n}\r\n\r\n.assignModal {\r\n  position: absolute;\r\n  z-index: 1;\r\n  left: 0;\r\n  top: 0;\r\n  width: auto; /* Adjust this value to change the size of the photo frame */\r\n  height: auto; /* Adjust this value to change the size of the photo frame */\r\n  perspective: 1000px;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  overflow: auto;\r\n  margin: 20px;\r\n  background-color: transparent!important;\r\n  border-color: transparent!important;\r\n  outline: transparent!important;\r\n}\r\n\r\n.assignModalContent {\r\n  background-color: black;\r\n  z-index: 1;\r\n  position: absolute;\r\n  border-color: transparent!important;\r\n  outline: transparent!important;\r\n  perspective: 1000px;\r\n  margin: auto;\r\n  padding: 20px;\r\n  border: 20px solid #888;\r\n  width: 50%;\r\n  color: white;\r\n  position: relative;\r\n  overflow: auto;\r\n}\r\n\r\n  /* Modal styles */\r\n  .photo-modal2 {\r\n    display: block;\r\n    position: fixed;\r\n    z-index: 1;\r\n    left: 0;\r\n    top: 0;\r\n    width: 100%; /* Adjust this value to change the size of the photo frame */\r\n    height: 100%; /* Adjust this value to change the size of the photo frame */\r\n    perspective: 1000px;\r\n    overflow: auto;\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    margin: 0px;\r\n    background-color: black!important;\r\n    border-color: transparent!important;\r\n    outline: transparent!important;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
